import React from 'react';
import PageHeader from './global-components/page-header';
import ContactForm from './section-components/contact-form';
import Map from './section-components/map';
import MainLayout from 'components/layouts/MainLayout';

const ContactV1 = () => {
    return <div>
        <MainLayout>
        <PageHeader customclass="mb-5" headertitle="CUÉNTANOS TU IDEA" subheader="Contáctanos" />
        <ContactForm />
        <Map />
        </ MainLayout>
    </div>
}

export default ContactV1

